"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeviceControlInbound = exports.DeviceControlOutbound = exports.DeviceCommandKinds = exports.DeviceTelemetry = exports.NetTypes = exports.KioskLevels = void 0;
const zod_1 = require("zod");
const device_config_schema_js_1 = require("./device-config.schema.js");
exports.KioskLevels = ['device_owner', 'immersive', 'none'];
exports.NetTypes = ['wifi', 'ethernet', 'cellular', 'none'];
exports.DeviceTelemetry = zod_1.z.object({
    app_version: zod_1.z.string().min(1),
    wrapper_version: zod_1.z.string().min(1),
    kiosk_level: zod_1.z.enum(exports.KioskLevels),
    uptime_s: zod_1.z.number().int().nonnegative(),
    battery_pct: zod_1.z.number().int().min(0).max(100).nullable().optional(),
    is_charging: zod_1.z.boolean(),
    storage_free_mb: zod_1.z.number().int().nonnegative(),
    mem_free_mb: zod_1.z.number().int().nonnegative(),
    net_type: zod_1.z.enum(exports.NetTypes),
    current_composer_id: zod_1.z.string().uuid().nullable().optional(),
    current_item_label: zod_1.z.string().nullable().optional(),
    screen_on: zod_1.z.boolean(),
    // Screen-inventory (SP2): best-effort self-reported GPS (optional; admin
    // manual pin takes precedence server-side). accuracy in metres.
    gps_lat: zod_1.z.number().min(-90).max(90).nullable().optional(),
    gps_lng: zod_1.z.number().min(-180).max(180).nullable().optional(),
    gps_accuracy: zod_1.z.number().nonnegative().nullable().optional(),
    last_boot_at: zod_1.z.string().datetime(),
    ts: zod_1.z.string().datetime(),
});
exports.DeviceCommandKinds = [
    'device.relaunch',
    'device.clear_cache',
    'device.set_volume',
    'device.reboot', // W2 — device-owner only
    'device.screenshot', // W2 — PWA web-content capture
];
exports.DeviceControlOutbound = zod_1.z.discriminatedUnion('type', [
    zod_1.z.object({
        type: zod_1.z.literal('command'),
        command_id: zod_1.z.string().uuid(),
        command_type: zod_1.z.enum(exports.DeviceCommandKinds),
        args: zod_1.z.record(zod_1.z.unknown()),
    }),
    zod_1.z.object({
        type: zod_1.z.literal('config'),
        config_version: zod_1.z.number().int().nonnegative(),
        values: device_config_schema_js_1.DeviceConfigValues,
    }),
]);
exports.DeviceControlInbound = zod_1.z.discriminatedUnion('type', [
    zod_1.z.object({ type: zod_1.z.literal('telemetry'), telemetry: exports.DeviceTelemetry }),
    zod_1.z.object({
        type: zod_1.z.literal('command_ack'),
        command_id: zod_1.z.string().uuid(),
        status: zod_1.z.enum(['acked', 'done', 'failed']),
        error: zod_1.z.string().nullable().optional(),
    }),
    zod_1.z.object({
        type: zod_1.z.literal('screenshot_result'),
        command_id: zod_1.z.string().uuid(),
        image_b64: zod_1.z.string().min(1).max(12_000_000),
        mime: zod_1.z.literal('image/png'),
    }),
]);
//# sourceMappingURL=device-control.schema.js.map